// extracted by mini-css-extract-plugin
export default {"title":"W_NotificatonsTab_title__Y-2UG","wrapper":"W_NotificatonsTab_wrapper__SGcya","notifications_list":"W_NotificatonsTab_notifications_list__BfOoq"};